
//import DragDropTouch from './DragDropTouch'
//import Fabric from './../MessageCreator/Fabric.vue'
import MessageCreator from './../MessageCreator'
import ShareUI from "./../ShareUI";
import { blueyetiStates } from '@/utils/blueyetiStates'
import FileSaver from 'file-saver';
//import { hoverontouch } from './../../utils/hoverontouch'
import { sync } from 'vuex-pathify'
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import Swatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import { WebCam } from "@/utils/vue-web-cam/src";
import KeyboardUI from "./../KeyboardUI";
// import "simple-keyboard/build/css/index.css";
import VueTimers from 'vue-timers';
import Vue2TouchEvents from 'vue2-touch-events'
import VueCircle from 'vue2-circle-progress/src/index.vue'
// import {Vue2Dragula} from 'vue2-dragula'
import axios from 'axios'

// SVG ICons
import StickerThumb from './../../assets/appIcons/ASSET_Custom.svg';
import PictureTumb from './../../assets/appIcons/ASSET_Picture.svg';
import PicturePortraitTumb from './../../assets/appIcons/ASSET_Picture_portrait.svg';
import CountdownAnim from '@/components/CountdownAnim';
import PublishAnim from './../../assets/appIcons/ASSET_Publish.svg';
import BackBtn from './../../assets/appIcons/arrow-back.svg';
import BrushBtn from './../../assets/appIcons/BTN_Brush.svg';
import ChalkBtn from './../../assets/appIcons/BTN_Chalk.svg';
import CheckBtn from './../../assets/appIcons/BTN_Check.svg';
import CrossBtn from './../../assets/appIcons/BTN_Cross.svg';
import CrossMobileBtn from './../../assets/appIcons/BTN_CrossMobile.svg';
import HomeBtn from './../../assets/appIcons/BTN_Home.svg';
//import HomeAdminBtn from './../../assets/appIcons/BTN_HomeAdmin.svg';
import CustomBtn from './../../assets/appIcons/BTN_Custom.svg';
import PaintBtn from './../../assets/appIcons/BTN_Paint.svg';
//import PlusBtn from './../../assets/appIcons/BTN_Plus.svg';
import ReturnBtn from './../../assets/appIcons/BTN_Return.svg';
import SendBtn from './../../assets/appIcons/BTN_Send.svg';
import ShootPhotoBtn from './../../assets/appIcons/BTN_Shoot-PHOTO.svg';
import ShootVideoBtn from './../../assets/appIcons/BTN_Shoot-VIDEO.svg';
import StopBtn from './../../assets/appIcons/BTN_Stop.svg';
import ShootModeToPhotoBtn from './../../assets/appIcons/BTN_Mode-PHOTO.svg';
import ShootModeToVideoBtn from './../../assets/appIcons/BTN_Mode-VIDEO.svg';
import SprayBtn from './../../assets/appIcons/BTN_Spray.svg';
import StickersBtn from './../../assets/appIcons/BTN_Stickers.svg';
import TextBtn from './../../assets/appIcons/BTN_Text.svg';
import TrashBtn from './../../assets/appIcons/BTN_Trash.svg';
import ValidateBtn from './../../assets/appIcons/BTN_Validate.svg';
//import TrashAdminBtn from './../../assets/appIcons/BTN_TrashAdmin.svg';



export default {
   name: 'message-ui',
   mixins: [blueyetiStates],
   components: {
      MessageCreator, ShareUI, swiper, swiperSlide, Swatches, WebCam, KeyboardUI, VueCircle,
      StickerThumb, PictureTumb, PicturePortraitTumb, CountdownAnim, PublishAnim, BackBtn, BrushBtn, ChalkBtn, CheckBtn, CrossBtn, CrossMobileBtn, HomeBtn, PaintBtn,
      CustomBtn, ReturnBtn, SendBtn, ShootPhotoBtn, ShootVideoBtn, StickersBtn, SprayBtn, StopBtn, TextBtn, TrashBtn, ValidateBtn
   },
   props: {
      themeId: {
         type: Number,
         default: 500
      },
      themedata: {
         type: Object,
         default() { return {}; }
      },
   },
   data () {
      return {
         messageBlob: "toto",
         byst_active_states: [],
         byst_active_all_states: true,
         byst_active_except: ["gallery/*"],
         shootModeVideo: false,
         message_reduction: 1.0,
         shootPhotoNb: 10,
         shootPhotoIndex: 0,
         currentBackgroundIndex: 0,
         currentBackgroundType: "",
         currentBackgroundImage: "./img/themes/1/backgrounds/01_auditorium.jpg",
         watermark: "",
         isUserCustomInactive: true,
         isIdleDragging: false,
         showCustomUI: true,
         isDrawingMode: false,
         isVideoTimerActive: false,
         enableUndo: false,
         colors: ["#f63820", "#ffd800", "#d82698", "#4f008f","#01249a","#000000","#fe7209","#1890aa"],
         swatchescolors: [
                '#000000',
                '#333333',
                '#999999',
                '#CCCCCC',
                { color: '#EEEEEE', showBorder: true },
                { color: '#F4F4F4', showBorder: true },
                { color: '#FFFFFF', showBorder: true }
            ],
         currentColor: "#000000",
         currentBrushType: "pencilBrush",
         currentBrushSize: "small",
         currentBrushSizeNumber: 4,
         somethingSelected: false,
         camera: null,
         deviceId: null,
         devices: [],
         camCaptureImg: null,
         currentID: 0,
         gifIsComputed: false,
         upload_progress: 0,
         fileSent: false,
         navigatorCanShare: false,
         input: "",
         currentFilter: "none",
         currentCSSFilter: "filter:none;",
         CSSFilters: { // css params of filters
            none: 'none',
            black: 'grayscale(1)',
            grayscale: 'grayscale(1)',
            sepia: 'sepia(1)',
            saturate: 'brightness(80%) saturate(4) contrast(150%)',
            black_and_white:'saturate(0%) grayscale(100%) brightness(150%) contrast(200%)'
         },
         swiperOption: {
            slidesPerView: 'auto',
            spaceBetween: -40,
            simulateTouch: true,
            centeredSlides: true,
            slideToClickedSlide: true,
            preloadImages:true,
            updateOnImagesReady:true,
            watchSlidesProgress:true,
            parallax:true,
            loop: true,
            pagination: {
               el: '.swiper-pagination',
               clickable: true
            }
         },
         stickersSwiperOption: {
            slidesPerView: 'auto',
            //slidesPerGroup: 6,
            direction: 'vertical',
            allowTouchMove: false,
            setWrapperSize: true,
            //initialSlide: 2,
            spaceBetween: 0,
            watchOverflow: true,
            simulateTouch: true,
            centeredSlides: false
         },
         stickers:
         [
         ],
         backgrounds:
         [
         ],
         defaultStickers:
         [
            { sticker_id:1,
               filename: "./img/themes/1/stickers/eventail.png",
               thumbnail: "./img/themes/1/stickers/thumbs/eventail.png"
            },
            { sticker_id:2,
               filename: "./img/themes/1/stickers/fish.png",
               thumbnail: "./img/themes/1/stickers/thumbs/fish.png"
            },
            { sticker_id:3,
               filename: "./img/themes/1/stickers/ChauveSouris_sticker.png",
               thumbnail: "./img/themes/1/stickers/thumbs/ChauveSouris_sticker.png"
            },
            { sticker_id:4,
               filename: "./img/themes/1/stickers/Couronne_sticker.png",
               thumbnail: "./img/themes/1/stickers/thumbs/Couronne_sticker.png"
            },
            { sticker_id:5,
               filename: "./img/themes/1/stickers/Mains_sticker.png",
               thumbnail: "./img/themes/1/stickers/thumbs/Mains_sticker.png"
            },
            { sticker_id:6,
               filename: "./img/themes/1/stickers/Poulet_sticker.png",
               thumbnail: "./img/themes/1/stickers/thumbs/Poulet_sticker.png"
            }
         ],
         defaultBackgrounds:
         [
            {
               background_id:1,
               type: "image",
               filename: "./img/themes/1/backgrounds/01_auditorium.jpg",
               thumbnail: "./img/themes/1/backgrounds/thumbs/01_auditorium.jpg",
               filename_portrait: "dossier/nom_du_fichier_portrait2.jpg",
               thumbnail_portrait: "dossier/nom_de_la_vignette_portrait2.jpg",
               display_stikers: true,
               colors: ["#f63820", "#ffd800", "#d82698", "#4f008f","#01249a","#000000","#fe7209","#1890aa"],
               brushes: "pencil",
               filter: "none"
            },
            {
               background_id:2,
               type: "selfie_mask",
               filename: "./img/themes/1/backgrounds/16_Basquiat.png",
               thumbnail: "./img/themes/1/backgrounds/thumbs/16_Basquiat.png",
               filename_portrait: "dossier/nom_du_fichier_portrait.jpg",
               thumbnail_portrait: "dossier/nom_de_la_vignette_portrait.jpg",
               display_stikers: false,
               colors: ["#f63820", "#ffd800", "#d82698", "#4f008f","#01249a","#000000","#fe7209","#1890aa"],
               brushes: "spray",
               filter: "grayscale"
            },
            {
               background_id:3,
               type: "image",
               filename: "./img/themes/1/backgrounds/02_eau.jpg",
               thumbnail: "./img/themes/1/backgrounds/thumbs/02_eau.jpg",
               filename_portrait: "dossier/nom_du_fichier_portrait2.jpg",
               thumbnail_portrait: "dossier/nom_de_la_vignette_portrait2.jpg",
               display_stikers: true,
               colors: ["#f63820", "#ffd800", "#d82698", "#4f008f","#01249a","#000000","#fe7209","#1890aa"],
               brushes: "crayon",
               filter: "none"
            },
            {
               background_id:4,
               type: "selfie_mask",
               filename: "./img/themes/1/backgrounds/03_grotto_selfiemask.png",
               thumbnail: "./img/themes/1/backgrounds/thumbs/03_grotto_selfiemask.png",
               filename_portrait: "dossier/nom_du_fichier_portrait2.jpg",
               thumbnail_portrait: "dossier/nom_de_la_vignette_portrait2.jpg",
               display_stikers: true,
               colors: ["#f63820", "#ffd800", "#d82698", "#4f008f","#01249a","#000000","#fe7209","#1890aa"],
               brushes: "marker",
               filter: "sepia"
            },
            {
               background_id:5,
               type: "image",
               filename: "./img/themes/1/backgrounds/04_cascade.jpg",
               thumbnail: "./img/themes/1/backgrounds/thumbs/04_cascade.jpg",
               filename_portrait: "dossier/nom_du_fichier_portrait2.jpg",
               thumbnail_portrait: "dossier/nom_de_la_vignette_portrait2.jpg",
               display_stikers: false,
               colors: ["#f63820", "#ffd800", "#d82698", "#4f008f","#01249a","#000000","#fe7209","#1890aa"],
               brushes: "ink",
               filter: "none"
            },
            {
               background_id:6,
               type: "selfie",
               filename: "./img/themes/1/backgrounds/04_cascade.jpg",
               thumbnail: "./img/themes/1/backgrounds/thumbs/04_cascade.jpg",
               filename_portrait: "dossier/nom_du_fichier_portrait2.jpg",
               thumbnail_portrait: "dossier/nom_de_la_vignette_portrait2.jpg",
               display_stikers: true,
               colors: ["#f63820", "#ffd800", "#d82698", "#4f008f","#01249a","#000000","#fe7209","#1890aa"],
               brushes: "pencil",
               filter: "none"
            }
         ]
      }
   },
   timers: {
      countdownEnd: { time: 4000, autostart: false },
      shootPhotoStart: { time: 150, autostart: false },
      shootPhotoEnd: { time: 50, autostart: false },
      gotoCustomSelfieImage: { time: 500, autostart: false },
      backgroundImageLoaded: { time: 500, autostart: false },
      userActiveDel: { time: 0, autostart: false },
      userInactiveDel: { time: 800, autostart: false },
   },
   computed: {
      content: sync('content'),
      os: sync('os'),
      is_in_app: sync('is_in_app'),
      photo_message_width: sync('photo_message_width'),
      photo_message_height: sync('photo_message_height'),
      message_width: sync('message_width'),
      message_height: sync('message_height'),
      video_message_reduction: sync('video_message_reduction'),
      desk_camera_name: sync('desk_camera_name'),
      isPortrait: sync('isPortrait'),
      messageId: sync('messageId'),
      menuScale: sync('menuScale'),
      host_address: sync('host_address'),
      api_address:sync('api_address'),
      token:sync('token'),
      messageDataURL: sync('messageDataURL'),
      themeMainColor: sync('themeMainColor'),
      theme_id: sync('settings@theme_id'), //id thème
      privat_id:  sync('settings@privat_id'),
      swiper() {
         return this.$refs.backgroundSlides.swiper
      },
      stickersSwiper() {
         return this.$refs.stickersSlides.swiper
      },
      device: function() {
         console.log(this.devices.find(n => n.deviceId === this.deviceId))
         return this.devices.find(n => n.deviceId === this.deviceId);
      },
      undoOpacity () {
         return this.enableUndo ? '1' : '0.3';
      },

      real_message_width () {
         return this.message_width * window.devicePixelRatio;
      },

      real_message_height () {
         return this.message_height  * window.devicePixelRatio;
      },
      textColorStyle() {
         //return "style:'color: white;'" ;
         return "color: " + this.currentColor + ";    border: 3px solid " + this.currentColor + ";" ;
      },
      gifCircleSize () {
         if (this.message_width > this.message_height)
         return this.message_height * 0.4;
         else
         return this.message_width * 0.4;
      }




      // brushSizeNumber() {
      //    if (this.brushsize == 'small')
      //       return 1;
      //    else if (this.brushsize == 'medium')
      //       return 5;
      //    else
      //       return 10;
      // }

   },
   updated () {
      if (this.$refs.backgroundSlides.swiper.animating)
      {
         console.log('swipeMove');

      }
   },
   created () {
      console.log('created');
      this.backgrounds = this.themedata.backgrounds;
      this.stickers = this.themedata.stickers;
      if(!this.isPortrait)
      this.watermark = this.themedata.watermark;
      else
      this.watermark = this.themedata.watermark_portrait;
      //that.backgrounds = that.defaultBackgrounds;
      //that.stickers = that.defaultStickers;

      // if (this.is_in_app && navigator.share === undefined) {
      //    console.error('Error: Unsupported feature: navigator.share()');
      //    this.navigatorCanShare = true;
      // }
      // else {
      //    this.navigatorCanShare = true;
      // }

      this.onThemeLoaded();
      this.setCurrentSlide(0);

   },
   mounted () {
      console.log('mounted');
      //var HoverOnTouch = new HoverOnTouch();
      //this.currentBackgroundIndex = $refs.backgroundSlides.swiper.realIndex;
      //this.$refs.backgroundSlides.swiper.update();

   },
   watch: {
      camera: function(id) {
         this.deviceId = id;
      },
      devices: function() {

         // Once we have a list select the first one
         const [first, ...tail] = this.devices;
         if (first) {
            this.camera = first.deviceId;
            this.deviceId = first.deviceId;
         }
         // if in desk mode there is a camera name, choose this camera
         if (!this.is_in_app && this.desk_camera_name != "") {
            console.log('desk_camera_name: ' + this.desk_camera_name);
            var that=this;
            this.devices.forEach(function(d) {
               console.log('label: ' + d.label);
               if(d.label == that.desk_camera_name) {
                  that.camera = d.deviceId;
                  that.deviceId = d.deviceId;
               }
            });
         }
      }
   },
   methods: {
      onThemeLoaded: function(){
         console.log('onThemeLoaded');
         var that=this;

         console.log('this.watermark ' + this.watermark);
         if(this.watermark.substring(0, 2) == '..'){
            this.watermark = that.host_address + this.watermark.slice(2);
         }
         //this.watermark = "http://popbook.anybug.fr/uploads/thematics/watermarkLandscape/5d2e27dc0b8dd_watermark.png"

         this.backgrounds.forEach(function(a) {
            //console.log("a.thumbnail " + a.thumbnail);
            if(a.thumbnail.substring(0, 2) == '..'){
               a.thumbnail = that.host_address + a.thumbnail.slice(2);
            }
            if(a.filename.substring(0, 2) == '..'){
               a.filename = that.host_address + a.filename.slice(2);
            }
            a.CSSFilter = that.CSSFilters[a.filter];
            console.log("type " + a.type);
            console.log("filter " + a.CSSFilter);
            // if (a.type =="Image")
            //    a.type ="image";
            // else if (a.type =="Selfie")
            //    a.type ="selfie";
            // else if (a.type =="Selfie + Mask")
            //    a.type ="selfie_mask";
         });

         this.stickers.forEach(function(a) {
            if(a.thumbnail.substring(0, 2) == '..'){
               a.thumbnail = that.host_address + a.thumbnail.slice(2);
            }
            if(a.filename.substring(0, 2) == '..'){
               a.filename = that.host_address + a.filename.slice(2);
            }
         });
         this.byst_SetState('shooting/choice');

         //this.$refs.creator.resetCanvas();
      },
      setCurrentSlide: function(index){
         this.currentBackgroundIndex = index;
         console.log('currentBackgroundIndex ' + this.currentBackgroundIndex);
         this.colors = this.backgrounds[this.currentBackgroundIndex].colors;
         this.swatchescolors = [];
         var that = this;
         this.colors.forEach(function(c) {
            if(c == '#FFFFFF') {
               that.swatchescolors.push({ color: c, showBorder: true });
            }
            else {
               that.swatchescolors.push(c);
            }
         });
         console.log('swatchescolors ');
         console.log(this.swatchescolors);


         if (this.colors.length > 0)
            this.currentColor = this.colors[0];
         else
            this.currentColor = "#000000";
         this.currentBackgroundType = this.backgrounds[this.currentBackgroundIndex].type;
         this.currentFilter = this.backgrounds[this.currentBackgroundIndex].filter;
         console.log('currentFilter ' + this.currentFilter);
         this.currentCSSFilter = "filter: " + this.CSSFilters[this.currentFilter] +";";
         console.log('currentCSSFilter ' + this.currentCSSFilter);
         if(this.currentBackgroundType!=='selfie') {
            this.currentBackgroundImage = this.backgrounds[this.currentBackgroundIndex].filename;
         } else {
            this.currentBackgroundImage = null;
         }
         console.log('currentBackgroundType ' + this.currentBackgroundType);
         // get brush type
         this.currentBrushType = this.backgrounds[this.currentBackgroundIndex].brushes;
         console.log('currentBrushType ' + this.currentBrushType);
         //this.$refs.creator.resetCanvas();
      },
      onSlideChange: function(){
         this.setCurrentSlide(this.$refs.backgroundSlides.swiper.realIndex);
      },
      onSlideTap: function(e){
         console.log('onSlideTap', e);
         //this.$refs.backgroundSlides.swiper.mySwiper.slideToLoop()
      },

      // onSliderMove: function(e){
      //    console.log('onSlideMove ' + this.$refs.backgroundSlides.swiper.realIndex, e);
      //    //this.$refs.backgroundSlides.swiper.mySwiper.slideToLoop()
      // },

      onSliderProgress: function(e){
         //console.log('onSlideProgress', e);
         //this.$refs.backgroundSlides.swiper.mySwiper.slideToLoop()
      },

      onStickerTap: function(e){
         console.log('onStickerTap', e);
      },

      gotoShare: function(e){
         this.byst_SetState('custom/share');
      },
      gotoGallery: function(e){
         //this.byst_SetState('gallery');
         location.reload();
      },
      gotoCustomImage: function(e){
         this.shootModeVideo = false;
         this.$refs.creator.resetCanvas();
         if(this.currentBackgroundType == 'image') {
            this.$refs.creator.addBackgroundImage();
         }
         this.$timer.start('backgroundImageLoaded');
      },
      backgroundImageLoaded: function(e){
         this.$timer.stop('backgroundImageLoaded');
         this.byst_SetState('custom/paint');
      },
      validatePaint: function(e){
         this.byst_SetState('custom/idle');
      },
      focusText: function(){
         if(this.byst_CompareCurrentStates(['custom/text'])){
            console.log("focus on text input");
            //this.$refs.textinput.focus();
            //this.$nextTick(() => this.$refs.textinput.focus())
            setTimeout(x => {
               this.$nextTick(() => this.$refs.textinput.focus()); // this works great, just watch out with going to fast !!!
            }, 100);         }
         },
         validateTextEnter: function(e){
            //console.log("validateTextEnter " + e);
            e.preventDefault();
            this.validateText(e);
         },
         validateText: function(e){
            //var tinput = document.getElementById('textinput');
            document.activeElement.blur();
            const top = this.$refs.textinput.getBoundingClientRect().top / this.message_reduction;
            //var topPos = tinput.getBoundingClientRect().top + window.scrollY;
            //var leftPos = tinput.getBoundingClientRect().left + window.scrollX;
            console.log("topPos " + top);
            this.$refs.creator.addText(this.input, this.currentColor, 50 * this.menuScale / this.message_reduction, this.message_width/2, top+20 * this.menuScale); //460
            this.input = "";
            if (this.$refs.keyboardui != undefined)
            this.$refs.keyboardui.reset();
            this.byst_SetState('custom/idle');
            this.$refs.textinput.blur();
         },
         startCountdown: function(type){
            this.shootModeVideo = type == "video";
            this.byst_SetState('shooting/countdown');
            if(!this.is_in_app) {
               if(type == "video") {
                  this.message_reduction =  this.video_message_reduction;
                  this.message_width = parseInt(this.photo_message_width / this.video_message_reduction);
                  this.message_height = parseInt(this.photo_message_height / this.video_message_reduction);
               } else {
                  this.message_reduction =  1;
                  this.message_width = this.photo_message_width;
                  this.message_height = this.photo_message_height;
               }
            }
            this.$refs.creator.resetCanvas();
            this.shootPhotoIndex = 0;
            this.$timer.start('countdownEnd')
            this.$emit('resetTimeOutTimer');

         },
         countdownEnd: function(){
            this.$timer.stop('countdownEnd')
            console.log('Countdown end');
            this.$emit('resetTimeOutTimer');
            this.shootPhotoStart();
         },
         onStopShooting: function(e){
            console.log('press stop');
         },
         shootPhotoStart: function(){
            this.$timer.stop('shootPhotoStart')
            console.log('shoot photo');
            this.$emit('resetTimeOutTimer');
            this.onCapture();
            this.$nextTick(() => {
               this.byst_SetState('shooting/shoot');
               this.$timer.start('shootPhotoEnd')
            });
         },
         // shootPhoto: function(e){
         //    this.onCapture();
         //    //this.byst_SetState('shooting/countdown');
         // },
         shootPhotoEnd: function(e){
            this.$timer.stop('shootPhotoEnd')
            if(this.shootModeVideo)
            {
               // loop to take 10 photos
               this.$refs.stopProgressCircle.updateProgress((this.shootPhotoIndex + 1) / (this.shootPhotoNb) * 100);
               this.$refs.stopProgressCircle.updateFill(this.themeMainColor);
               if(this.shootPhotoIndex < this.shootPhotoNb) {
                  this.byst_SetState('shooting/video');
                  this.$refs.creator.addCameraImage(this.currentFilter);
                  this.shootPhotoIndex++;
                  this.$nextTick(() => {
                     this.$timer.start('shootPhotoStart')
                  });
               }
               else {
                  this.byst_SetState('shooting/end');
                  this.$timer.start('gotoCustomSelfieImage')
               }
            }
            else { // image
               this.byst_SetState('shooting/end');
               this.$refs.creator.addCameraImage(this.currentFilter);
               this.$timer.start('gotoCustomSelfieImage')
            }
         },

         gotoCustomSelfieImage: function(e){
            this.$timer.stop('gotoCustomSelfieImage')
            this.$emit('resetTimeOutTimer');
            if(this.currentBackgroundType == 'selfie_mask') {

               this.$refs.creator.addBackgroundImage();
            }
            this.$timer.start('backgroundImageLoaded')
         },
         onColorChange: function (event) {
            //change fabricjs color
            console.log('new color ' + this.currentColor);
         },
         preventTouchMove: function (event) {
            console.log('touch move')
            event.preventDefault()
            //event.stopPropagation()
         },

         brushSizeChange: function (newsize) {
            //change fabricjs brush size
            console.log('new color ' + newsize);
            this.currentBrushSize = newsize;

            if (newsize == 'small')
            this.currentBrushSizeNumber = 4;
            else if (newsize == 'medium')
            this.currentBrushSizeNumber = 20;
            else
            this.currentBrushSizeNumber = 50;

         },
         dataURItoBlob: function(dataURI) {
            if(typeof dataURI !== 'string'){
               throw new Error('Invalid argument: dataURI must be a string');
            }
            dataURI = dataURI.split(',');
            var type = dataURI[0].split(':')[1].split(';')[0],
            byteString = atob(dataURI[1]),
            byteStringLength = byteString.length,
            arrayBuffer = new ArrayBuffer(byteStringLength),
            intArray = new Uint8Array(arrayBuffer);
            for (var i = 0; i < byteStringLength; i++) {
               intArray[i] = byteString.charCodeAt(i);
            }
            return new Blob([intArray], {
               type: type
            });
         },
         onValidateMessage: function(e){
            this.$refs.creator.unselectActiveObject();
            //         this.currentMessageDataURL = [];
            //         this.currentMessageDataURL.push(this.$refs.creator.toDataURL());
            console.log("onValidateMessage");
            this.messageDataURL = this.$refs.creator.toDataURL()
            if(!this.shootModeVideo) {
               this.messageBlob = (window.webkitURL || window.URL).createObjectURL(this.dataURItoBlob(this.messageDataURL));
               console.log("JPEG messageBlob");
               console.log(this.messageBlob);
               //this.$refs.share.print();
            }
            //this.$refs.creator.pauseVideoTimer();
            if(this.is_in_app)
            this.byst_SetState('custom/validate');
            else {
               //this.byst_SetState('custom/form');
               this.byst_SetState('custom/share');
               //this.$refs.share.renderForm();
            }
         },
         // // Takes a data URI and returns the Data URI corresponding to the resized image at the wanted size.
         // // Use it like : var newDataURI = await resizedataURL('yourDataURIHere', 50, 50);
         // resizedataURL: function(datas, wantedWidth, wantedHeight){
         //     return new Promise(async function(resolve,reject){
         //
         //         // We create an image to receive the Data URI
         //         var img = document.createElement('img');
         //
         //         // When the event "onload" is triggered we can resize the image.
         //         img.onload = function()
         //         {
         //             // We create a canvas and get its context.
         //             var canvas = document.createElement('canvas');
         //             var ctx = canvas.getContext('2d');
         //
         //             // We set the dimensions at the wanted size.
         //             canvas.width = wantedWidth;
         //             canvas.height = wantedHeight;
         //
         //             // We resize the image with the canvas method drawImage();
         //             ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
         //
         //             var dataURI = canvas.toDataURL();
         //
         //             // This is the return of the Promise
         //             resolve(dataURI);
         //         };
         //
         //         // We put the Data URI in the image's src attribute
         //         img.src = datas;
         //
         //     })
         // },
         sendMessageData: function(){
            //this.byst_SetState('custom/publish');
            console.log('sendMessageData');

            // if(this.navigatorCanShare) {

            // function blobToFile(theBlob, fileName){
            //    //A Blob() is almost a File() - it's just missing the two properties below which we will add
            //    theBlob.lastModifiedDate = new Date();
            //    theBlob.name = fileName;
            //    return theBlob;
            // }

            Date.prototype.YYYYMMDDHHMMSS = function () {
               var yyyy = this.getFullYear().toString();
               var MM = pad(this.getMonth() + 1,2);
               var dd = pad(this.getDate(), 2);
               var hh = pad(this.getHours(), 2);
               var mm = pad(this.getMinutes(), 2)
               var ss = pad(this.getSeconds(), 2)

               return yyyy + MM + dd+  hh + mm + ss;
            };

            function pad(number, length) {

               var str = '' + number;
               while (str.length < length) {
                  str = '0' + str;
               }

               return str;

            }
            var date = new Date();
            var filename = "";
            var messageFile;
            if(!this.shootModeVideo)
            filename = "popbook_" + date.YYYYMMDDHHMMSS() + ".jpg";
            else
            filename = "popbook_" + date.YYYYMMDDHHMMSS() + ".gif";
            //messageFile = blobToFile(this.messageBlob, filename);

            console.log("Filename " + filename);
            messageFile = new File([this.messageBlob], filename);
            if (this.os != 'iOS') {
               FileSaver.saveAs(this.messageBlob, filename);
            }

            // if (navigator.canShare && navigator.canShare( { files: [messageFile] } )) {
            //    navigator.share({
            //       files: [messageFile],
            //       title: 'PopBook',
            //       text: 'Votre message',
            //    })
            //    .then(() => console.log('Share was successful.'))
            //    .catch((error) => console.log('Sharing failed', error));
            // } else {
            //    console.log('Your system doesn\'t support sharing files.');
            //    this.navigatorCanShare = false;
            // }

            // }




            this.isSendingFile = false;
            var cid = this.currentID;
            var fileData = this.messageDataURL;
            const that = this;

            axios.post( this.api_address + 'message', {
               token:that.token,
               type: 'image',
               nb_images: 1,
               width: that.message_width,
               height: that.message_height,
               source: 'mobile',
               theme: that.theme_id,
               privat_id: that.privat_id,
               portrait: false,
               email: that.email,
               facebook: that.shareFacebook,
               print: that.sharePrint,
               form: that.formCompleted,
               newsletter: that.newsletter,
               contest: that.contest

            })
            .then(function (response) {
               console.log("response " + response.data);
               // console.log(response);
               // console.log(response.data);
               // console.log(JSON.parse(response.data).id);
               cid = JSON.parse(response.data).id;
               that.messageId = cid;

               //if(!that.navigatorCanShare)
               if (that.os == 'iOS') {
                  alert(that.content.ios_help_recording);
                  window.location = that.messageBlob;
               } else {
                  location.reload();
               }
            })
            .catch(function (error) {
               console.log(error);
               if (that.os == 'iOS') {
                  window.location = that.messageBlob;
               } else {
                  location.reload();
               }
               //if(!that.navigatorCanShare)
            });


            //this.$refs.publishanim.beginElement();
         },
         resetTimeOutTimer: function(){
            this.$emit('resetTimeOutTimer');
         },
         onGifCompute: function(e){
            console.log("gif creation " + e * 100);
            //this.gifProgress
            this.$refs.gifProgressCircle.updateProgress(e * 100);
            this.$refs.gifProgressCircle.updateFill(this.themeMainColor);
            this.gifIsComputed = true;
            if(!this.is_in_app) {
               this.$refs.share.onGifCompute(e);
            }
            this.$emit('resetTimeOutTimer');
            //this.gifIsComputed = false;
         },
         onGifReady: function(e){
            console.log("gif ready");
            this.gifIsComputed = false;
            this.messageBlob = (window.webkitURL || window.URL).createObjectURL(this.dataURItoBlob(this.messageDataURL));
            console.log("GIF messageBlob ");
            console.log(this.messageBlob);
            //this.$refs.share.print();
         },
         onBackToCustom: function(e){
            this.$refs.creator.hideWatermark();
            if (this.shootModeVideo)
            this.$refs.creator.playVideoTimer();
            this.byst_SetState('custom/idle');
         },
         onSendButton: function(e){
            this.$refs.share.onSend();
            console.log('send anim');
         },

         isUserInactive(val) {
            if(val != this.isUserCustomInactive)
            {
               this.$timer.stop('userActiveDel')
               this.$timer.stop('userInactiveDel')
               this.isUserCustomInactive = val;
               console.log('User Inactive ' + val);
               //if (val )
               if (val == true && this.byst_app_state == "custom/stickers")
               this.byst_SetState('custom/idle');
               if(!val)
               this.$timer.start('userActiveDel')
               else
               this.$timer.start('userInactiveDel')
            }
         },

         isSomethingSelected(val) {
            if(val != this.somethingSelected)
            {
               this.somethingSelected = val;
               console.log('somethingSelected ' + val);
            }
         },

         isDragging(val, x, y) {
            //console.log('User Dragging ' + val);
            if (val) {
               var endTarget = document.elementFromPoint(x, y);
               if (endTarget == this.$refs.trash)
               {
                  endTarget.classList.add("trash-btn-over");
               }
               else {
                  this.$refs.trash.classList.remove("trash-btn-over");
               }
            }

            if(val != this.isIdleDragging)
            {
               this.isIdleDragging = val;
               if (val == false)
               {
                  var endTarget = document.elementFromPoint(x, y);
                  if (endTarget == this.$refs.trash)
                  this.onDelete();
                  console.log("delete object");

                  //if (this.&refs.trash.left)
                  //var trash = document.getElementById('trash');
                  //console.log("trash " + trash.left + ", "+trash.top);    // Log to console
                  //console.log("mouse " + x+", "+y);    // Log to console
                  //this.onDelete();
               }
            }
         },

         userActiveDel: function(e){
            this.$timer.stop('userActiveDel')
            this.$timer.stop('userInactiveDel')
            this.showCustomUI = false;
         },
         userInactiveDel: function(e){
            this.$timer.stop('userActiveDel')
            this.$timer.stop('userInactiveDel')
            this.showCustomUI = true;
         },

         onTextSelected() {
            this.setFocus();
         },

         onUndo() {
            this.$refs.creator.undo();
         },

         onDelete() {
            this.$refs.creator.deleteLast();
         },

         onMove() {
            console.log("On Move");
         },

         // camera methods

         onCapture() {
            //         this.camCaptureImg = this.$refs.webcam.capture();
            this.camCaptureImg = this.$refs.webcam.capture();
         },
         onStarted(stream) {
            console.log("On Started Event", stream);
            console.log("width: " + stream.getVideoTracks()[0].getSettings().width + "height: " + stream.getVideoTracks()[0].getSettings().height );

         },
         onStopped(stream) {
            console.log("On Stopped Event", stream);
         },
         onStop() {
            console.log("On Stop Event", error);
            this.$refs.webcam.stop();
         },
         onStart() {
            console.log("On Start Event", error);
            this.$refs.webcam.start();
         },
         onError(error) {
            console.log("On Error Event", error);
         },
         onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
         },
         onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
         },

         // keyboard methods
         updateInput(input) {
            this.input = input;
         },
         onKbdChange(input) {
            this.input = input.substring(0, 55);
            console.log("onChange ", this.input);
         },
         onInputChange(e) {
            this.input = e.target.value;
            //this.$refs.keyboardui.setInput(input);
         },
         setFocus() {
            //let input = e.target.value;
            console.log("set focus");
            this.$nextTick(() => this.$refs.textinput.focus());

         },



      },
   }
